<template>
  <header-middle />
  <div class="container-" v-if="$route.name =='StoreInformation'">
    <information-template />
  </div>
  
  <div class="dir-rtl" v-else>
    <div class="container-fluid">
      <content-store :storeDetail="storeDetail" />
      <damp-template :damping="damping" />
      <category-template />
      <store-product :products="products" />
    </div>
  </div>	
  <grid-template />
  <footer-template />
</template>

<script setup>
import HeaderMiddle from '../section/header/header.vue';
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import ContentStore from "../section/pages/Store/contentTemp.vue";
import StoreProduct from "../section/pages/Store/products.vue";
import CategoryTemplate from "../section/pages/Store/categoryPc.vue";
import DampTemplate from "../section/pages/Store/DampTemp.vue";
import InformationTemplate from "../section/pages/Store/information.vue";

import {useRoute} from 'vue-router';
import {ref,reactive,onMounted,onUnmounted,computed,watch} from 'vue';
    const route = useRoute();
    let store_id = ref();
    let products = ref([])
    let damping = ref([])
    let newPage = computed(()=>route.params)
    watch(newPage,() => {
      console.log(1);
    })
    let storeDetail = reactive({
      id: '' ,
      name: '' ,
      category: '' ,
      categoryFa: '' ,
      address: '' ,
      city: '' ,
      description: '' ,
      user: '' ,
      telephone: '' ,
      mobile: '' ,
      lat: '' ,
      long: '' ,
      store_img1: '' ,
      social_telegram: '' ,
      social_instagram: '' ,
      delivery_cost: '' ,
      track_time: '' ,
      min_sale: '' ,
      timing: '' 
    })
    product()
    let productInterval;
    onMounted(() => {
      productInterval = setInterval(product,60000)
    })
    onUnmounted(() => {
      clearInterval(productInterval)
    })
    async function showStore(){
      store_id.value = route.params.id;
      	let response = await fetch ('https://radap.ir/Backend/api/section/pages/store/getDetail.php?id='+ store_id.value)
        let data = await response.json()
              storeDetail.id = data.id;
              storeDetail.name = data.name;
              storeDetail.category = data.category;
              storeDetail.categoryFa = data.category_fa;
              storeDetail.address = data.address;
              storeDetail.city = data.city;
              storeDetail.description = data.description;
              storeDetail.user = data.user;
              storeDetail.timing = data.timing;
              storeDetail.telephone = data.telephone;
              storeDetail.mobile = data.mobile;
              storeDetail.track_time = data.track_time;
              storeDetail.lat = data.lat;
              storeDetail.long = data.long;
              storeDetail.store_img1 = data.store_img1;
              storeDetail.social_instagram = data.social_instagram;
              storeDetail.delivery_cost = data.delivery_cost;
              storeDetail.min_sale = data.min_sale;
              // if(storeDetail.category == "سوپر مارکت"){
              //   typeCategroy.value = 1
              // }else if(storeDetail.category == "رستوران"){
              //   typeCategroy.value = 2
              // }else if(storeDetail.category == "میوه"){
              //   typeCategroy.value = 3
              // }
    }
    async function product(){
          store_id.value = route.params.id;
        	let response = await fetch('https://radap.ir/Backend/api/section/pages/store/getProducts_new.php?id='+ store_id.value)
          let data = await response.json()
            products.value = data.data;
            damping.value = data.damp;
            showStore()
    }
</script>

<style scoped>


.container-fluid{
    --bs-gutter-x: 0 !important;
}
</style>